module.exports = {
  title: '前视检测管理平台',
  // cookie 存储的 key
  TokenKey: 'QSJC_Admin_Token',
  UserIdKey: 'QSJC_Admin_UserId',
  AccountKey: 'QSJC_Admin_Account',
  // cookie 过期时间 30天
  CookiesExpires: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000)
};
